<template>
  <div>
    <div class="custclue-container">
      <div class="card b-g-w">
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-putcontract"></use>
          </svg>
          <span>{{ customer.contractName }}</span>
        </div>
        <!-- <div class="title_name " v-if="customer.contractSource == '2'">
          {{ customer.contractName }}
        </div>
        <div class="card-box" v-else>
          <span class="key">合同标题：</span>
          <span class="value">{{ customer.contractName }}</span>
        </div> -->
        <div class="van-hairline--top section">
          <div class="card-box">
              <span class="key">合同类型：</span>
              <span class="value">{{
                contractTypeFormat2(customer.contractType)
              }}</span>
          </div>
          <div class="card-box">
            <span class="key">合同编号：</span>
            <span class="value">{{ customer.contractNum }}</span>
          </div>
          <div class="card-box" v-if="customer.contractSource == '2'">
            <div class="flex-1">
              <span class="key3">回款总金额：</span>
              <span class="value">{{ customer.allReturnedMoney }}</span>
            </div>
            <div class="flex-1">
              <span class="key3">未回款金额：</span>
              <span class="value">{{ customer.noReturnedMoney }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key">合同状态：</span>
              <span class="value">{{
              contractStatusFormat2(customer.contractStatus)
            }}</span>
            </div>
            <div class="flex-1">
              <span class="key">支付方式：</span>
              <span class="value">{{ payModeFormat2(customer.payMode) }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key">合同金额：</span>
              <span class="value">{{ customer.contractMoney }}</span>
            </div>
          </div>
          <div class="card-box" v-if="customer.contractType==1">
            <div class="flex-1">
              <span class="key">业务类型：</span>
              <span class="value">{{ customer.serviceTypeName }}</span>
            </div>
          </div>
          <div class="card-box" v-if="customer.contractType==1">
            <div class="flex-1">
              <span class="key">产品类型：</span>
              <span class="value">{{ customer.businessTypeName }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key3">对方签约人：</span>
              <span class="value">{{ customer.custSignedUser }}</span>
            </div>
            <div class="flex-1">
              <span class="key">对方电话：</span>
              <span class="value">{{ customer.signedUserMobile }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key3">我方签约人：</span>
              <span class="value">{{ customer.mySignedUser }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key">开始时间：</span>
              <span class="value">{{ customer.startTime | timeFormat }}</span>
            </div>
          </div>
          <div class="card-box">
            <div class="flex-1">
              <span class="key">结束时间：</span>
              <span class="value">{{ customer.endTime | timeFormat }}</span>
            </div>
          </div>
        </div>

      </div>
      <div class="card b-g-w payimg" v-if="customer.contractImg">
        <div class="imgList">
          <img v-for="item in captureList" :key="item" :src="item" class="img" alt="合同相片" @click="getImg(item)" />
        </div>
      </div>
      <!-- <van-grid style="margin-left:5px;margin-right:5px;margin-bottom:15px;" v-if="customer.contractFile || customer.annexOne || customer.annexTwo">

        <van-grid-item>
          <div class="flex-center" v-if="customer.contractFile">
            <van-icon name="description" size="15" color="#07c160" />
            <span class="grid-span-1"  @click="readFile(customer.contractFile,'查看电子合同信息')">查看电子合同信息</span>
          </div>
        </van-grid-item>
 
        <van-grid-item>
          <div class="flex-center" v-if="customer.annexOne">
            <van-icon name="description" size="15" color="#07c160" />
            <span class="grid-span-1"  @click="readFile(customer.annexOne,'查看附件1信息')">查看附件1</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.annexTwo">
            <van-icon name="description" size="15" color="#07c160" />
            <span class="grid-span-1"  @click="readFile(customer.annexTwo,'查看附件2信息')">查看附件2</span>
          </div>
        </van-grid-item>
        <van-grid-item>
        </van-grid-item>
    </van-grid>  -->
      <van-grid v-if="customer.contractFile || customer.annexOne || customer.annexTwo">
        <van-grid-item>
          <div class="flex-center" v-if="customer.contractFile">
            <van-icon name="label-o" size="22" color="rgb(57, 118, 198)" />
            <span class="grid-span"><a :href="customer.contractFile" @click="downloadUrlFile(customer.contractFile,customer.custName+'的电子合同')">电子合同</a></span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.annexOne">
            <van-icon name="label-o" size="22" color="rgb(57, 118, 198)" />
            <span class="grid-span"><a :href="customer.annexOne" @click="downloadUrlFile(customer.annexOne,customer.custName+'的附件1')">附件1</a></span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.annexTwo">
            <van-icon name="label-o" size="22" color="rgb(57, 118, 198)" />
            <span class="grid-span"><a :href="customer.annexTwo" @click="downloadUrlFile(customer.annexTwo,customer.custName+'的附件2')">附件2</a></span>
          </div>
        </van-grid-item>
      </van-grid>
      <!--customer.verifyStatus  合同审核状态   0：未审核 1：已通过 2：驳回  -->
      <van-grid v-show="customer.verifyStatus != '1' && customer.contractSource != '2' && !isInvoice">
        <van-grid-item>
          <div class="flex-center" v-if="customer.verifyStatus == '0'" v-hasPermi="['cont:nocontract:edit']">
            <van-icon name="edit" size="22" color="#07c160" />
            <span class="grid-span" @click="handleUpdate(customer)">修改</span>
          </div>
          <div class="flex-center" v-if="customer.verifyStatus == '2'" v-hasPermi="['cont:failcontract:edit']">
            <van-icon name="edit" size="22" color="#07c160" />
            <span class="grid-span" @click="handleUpdate(customer)">修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.verifyStatus == '0'" v-hasPermi="['cont:nocontract:verify']">
            <van-icon name="success" size="22" color="#0080FF" />
            <span class="grid-span" @click="handleSuccess(customer)">审核通过</span>
          </div>          
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="customer.verifyStatus == '0'" v-hasPermi="['cont:nocontract:verify']">
            <van-icon name="cross" size="22" color="#FE2E2E" />
            <span class="grid-span" @click="handleFail(customer)">审核驳回</span>
          </div>                
        </van-grid-item>
        <van-grid-item> </van-grid-item>
      </van-grid>

      <van-grid v-show="customer.contractSource == '2' && !isInvoice">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:othercontract:edit']">
            <van-icon name="edit" size="22" color="#07c160" />
            <span class="grid-span" @click="handleUpdate(customer)">修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:othercontract:remove']">
            <van-icon name="delete-o" size="22" color="#f76f6c" />
            <span class="grid-span" @click="handleDelete(customer.contractId)">删除</span>
          </div>
        </van-grid-item>
        <van-grid-item> </van-grid-item>
        <van-grid-item> </van-grid-item>
      </van-grid>
      <!-- <div class="card b-g-w payimg" v-if="customer.contractFile">
           <a :href="customer.contractFile" @click="downloadUrlFile(customer.contractFile,customer.custName+'的电子合同')">电子合同</a>
          <div>
            <pdf
              ref="pdf"
              v-for="i in numPages" 
              :key="i"  
              :src="pdfSrc" 
              :page="i"
              ></pdf>
          </div>
      </div> -->
      <!-- <van-dialog v-model="readFiles" :title="readTitle">
        <div class="pdf-box">
          <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i"> </pdf>
        </div>
      </van-dialog> -->

      <!--修改合同信息-->
      <van-dialog v-model="show" title="修改合同信息" width="95%" style="height:80%" class="editClue" :beforeClose="editContractBeforeClose" close-on-click-overlay>
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-cell-group>
            <van-field v-model="form.contractName" label="合同标题" :rules="[{ required: true }]" required placeholder="请填写合同标题" />
            <van-field v-model="form.contractNum" label="合同编号" :rules="[{ required: true }]" required placeholder="请填写合同编号" />
            <van-field v-model="form.contractMoney" label="合同金额" :rules="[{ required: true }]" required placeholder="请填写合同金额" />
            <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" required placeholder="请选择合同类型" />
            <van-field readonly clickable v-model="form.serviceTypeName" @click="showPicker('serviceTypeId')" v-if="form.contractType==1" label="业务类型" :rules="[{ required: true }]" placeholder="请选择产品类型" required />
            <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker('businessTypeId')" v-if="form.contractType==1" label="产品类型" :rules="[{ required: true }]" placeholder="请选择产品类型" required />
            <van-field readonly clickable v-model="form.contractStatusName" @click="showPicker('contractStatus')" label="合同状态" placeholder="请选择合同状态" />
            <van-field readonly clickable v-model="form.payModeName" @click="showPicker('payMode')" label="支付方式" required placeholder="请选择支付方式" />
            <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required />
            <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
            <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
            <van-field v-model="form.custSignedUser" label="对方签约人" placeholder="请填写对方签约人" />
            <van-field v-model="form.signedUserMobile" label="对方电话" placeholder="请填写对方电话" />
            <van-field v-model="form.mySignedUser" label="我方签约人" :rules="[{ required: true }]" required placeholder="请填写我方签约人" />
            <van-field name="uploader" label="合同相片">
              <template #input>
                <van-uploader v-model="pictureList" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
              </template>
            </van-field>
            <van-field name="rate" label="电子合同">
              <template #input>
                <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
                </van-uploader>
              </template>
            </van-field>
            <van-field name="rate" label="附件1">
              <template #input>
                <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
                </van-uploader>
              </template>
            </van-field>
            <van-field name="rate" label="附件2">
              <template #input>
                <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
                </van-uploader>
              </template>
            </van-field>
            <van-field v-model="form.remark" label="备注" />
            <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
          </van-cell-group>
        </van-form>
      </van-dialog>

      <!-- 日期选择器 -->
      <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
      <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
      <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup>
    </div>
  </div>
</template>

<script>
// import pdf from 'vue-pdf'
import moment from "moment";
import {
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Divider,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Grid,
  GridItem,
  Uploader,
  ImagePreview,
  Image,
  Form,
  Calendar,
} from "vant";
import { getNoContract, updateNoContract, verifyContract } from "@/api/cont/nocontract";
import { getFailContract, updateFailContract } from "@/api/cont/failcontract";
import { getContract } from "@/api/cont/contract";
import { getNoInvoiceContract } from "@/api/fina/noinvoice";
import { selectAllBusinessType } from "@/api/scrm/custbusinesstype";
import {
  addOtherContract,
  getOtherContract,
  updateOtherContract,
  delOtherContract,
} from "@/api/cont/othercontract";
import { getNonBusinessContract, delnonContract, updateNonContract } from "@/api/cont/nonbusinesscontract";
import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { areaList } from "@vant/area-data";
import { ucloudUpFileToContract, deleteFileToUcloud } from "@/api/system/common";
import {
  queryListContact,
  listContact,
  getContact,
  addContact,
  updateContact,
} from "@/api/scrm/custcontact";
import { queryListVisit } from "@/api/scrm/custvisit";
import { error } from "weixin-js-sdk";
import { getDict } from "@/utils/dict";

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Divider.name]: Divider,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Uploader.name]: Uploader,
    [Image.name]: Image,
    [Form.name]: Form,
    [Calendar.name]: Calendar,
    [ImagePreview.Component.name]: ImagePreview.Component,
    // pdf
  },
  filters: {
    timeFormat(val) {
      if (val != null && val.length > 0) {
        return moment(val).format("YYYY-MM-DD");
      }

    },
  },
  metaInfo: {
    //  这里是给页面修改
    title: "",
    meta: [
      { charset: "utf-8" },
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
        areaList,
      },
      pdfSrc: "", // pdf文件地址
      numPages: 0,
      customer: {},
      // 提单参数
      orderForm: {},
      listVisit: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户回访类型
      custVisitTypeOptions: this.$store.state.dictOptions.custVisitType||[],
      // 商机状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      //客户联系人列表
      custContactOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户等级
      custLevelOptions: [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      //投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      //产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree|| [],
      // 业务类型树选项
      serviceTypeTreeOptions: this.$store.state.dictOptions.serviceTypeTree || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      fileList: [],
      fileList1: [],
      fileList2: [],
      deleteFileToUcloudList: [],
      captureList: [],
      pictureList: [],
      show: false,
      order: false,
      other: false,
      readFiles: false,
      isInvoice: false,
      readTitle: "",
      active: 0,
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractImg: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      //回访记录
      visitForm: {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null,
      },
      //客户联系人查询条件
      queryContactParams: {
        pageNum: 1,
        pageSize: 100,
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
      },
    };
  },
  created(){
    let flag = this.$store.state.dictOptions;
    if(flag && flag.contractStatus.length>0){}else{
       getDict();
    }
  },
  mounted() {
    this.getCustLevelList();
    this.init();
    this.queryListVisit();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "CONT-合同详情";
      let { id, verifyStatus, contractSource, contractType, isInvoice } = this.$route.query;
      this.isInvoice = isInvoice
      this.visitForm.contractId = id;
      this.queryContactParams.contractId = id;
      let res = null;
      if (contractSource == "2") {
        if (contractType === "2") {
          res = await getNonBusinessContract(id);
        } else {
          res = await getOtherContract(id);
        }

      } else if (verifyStatus == "0") {
        res = await getNoContract(id);
      } else if (verifyStatus == "1") {
        if (this.isInvoice) {
          res = await getNoInvoiceContract(id);
        } else {
          res = await getContract(id);
        }
      } else if (verifyStatus == "2") {
        res = await getFailContract(id);
      }
      if (res.code === 200) {
        this.customer = res.data;
        if (this.customer.contractImg != null && this.customer.contractImg.length > 0) {
          this.captureList = this.customer.contractImg.split(",");
        }
      }
    },
    contractTypeFormat2(contractType) {
      let label = this.selectDictLabel(this.contractTypeOptions, contractType);
      if(label){
        return label
      }else{
        if(contractType == 6){
          return "2022销售合同"
        }else{
          return ''
        }
      }
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus);
    },
    //支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode);
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.contractForm.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    // getNumPages(url) {
    //   let loadingTask = pdf.createLoadingTask(url)
    //   loadingTask.promise.then(pdf => {
    //     this.numPages = pdf.numPages
    //   }).catch(err => {
    //     console.error('pdf 加载失败', err);
    //   })
    // },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        Toast("请上传 jpg 、jpeg、png 格式图片");
        return false;
      }
      return true;
    },
    // 返回布尔值
    beforeFileRead(file) {
      if (file.type !== "pdf") {
        Toast("请上传 pdf 格式图片");
        return false;
      }
      return true;
    },
    // 获取客户等级名称———详情显示时
    custLevelFormat2(custLevelId) {
      if (this.custLevelOptions != null) {
        let obj = this.custLevelOptions.find(
          (item) => item.custLevelId === custLevelId
        );
        if (obj != null) {
          return obj.levelName;
        }
      }
    },
    saveAs(data, name) {
      const urlObject = window.URL || window.webkitURL || window;
      const export_blob = new Blob([data]);
      const save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
      save_link.href = urlObject.createObjectURL(export_blob);
      save_link.download = name + '.pdf';
      save_link.click();
    },
    downloadUrlFile(url, fileName) {
      const url2 = url.replace(/\\/g, '/');
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url2, true);
      xhr.responseType = 'blob';
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      // 为了避免大文件影响用户体验，建议加loading
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName);
        }
      };
      xhr.send();
    },
    getImg(images) {
      ImagePreview({
        images: [images],
        showIndex: false,
        loop: false,
      });
    },
    getNumPages(url) {
      var loadingTask = pdf.createLoadingTask(url);
      // this.pdfSrc = pdf.createLoadingTask(url)
      loadingTask.promise.then((pdf) => {
        this.pdfSrc = loadingTask;
        this.numPages = pdf.numPages;
        console.log(this.numPages);
      });
    },
    /** 转换产品类型数据结构 */
    businessNormalizer(node) {
      console.log(node);
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      };
    },
    /** 转换业务类型数据结构 */
    serviceNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].serviceTypeId,
            text: node.children[i].serviceTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.serviceTypeId,
        text: node.serviceTypeName,
        children: arr
      };
    },
    //获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then((response) => {
        this.custLevelOptions = response.data;
      });
    },
    //获取客户联系人记录列表
    getCustContactList(custId) {
      //选择客户时获取该客户的联系人对象
      this.queryContactParams.custId = custId;
      queryListContact(this.queryContactParams).then((response) => {
        this.custContactOptions = response.data;

        alert(JSON.stringify());
      });
    },
    async queryListVisit() {
      const res = await queryListVisit({ custId: this.$route.params.id });
      console.log(res);
      if (res.code === 200) {
        this.listVisit = res.data;
      }
    },
    handleContractRemove(file) {
      let picture = this.form.contractImg;
      console.log(file.url);
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(",") == -1) {
          picture = null;
        } else {
          picture = picture.replace(file.url + ",", "");
        }
      } else {
        picture = picture.replace("," + file.url, "");
      }
      this.form.contractImg = picture;
      console.log(this.form.contractImg);
      this.pictureList = [];
      if (this.form.contractImg != null && this.form.contractImg.length > 0) {
        let payCaptures = this.form.contractImg.split(",");
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element,
          });
        });
      }
      this.deleteFileToUcloudList.push(file.url);
      console.log(this.deleteFileToUcloudList);
    },
    uploadContractPictureFiles(file) {
      console.log(file);
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            // this.form.contractImg = res.url;
            let picture = this.form.contractImg;
            if (picture != null && picture.length > 0) {
              picture += "," + res.url;
            } else {
              picture = res.url;
            }
            this.form.contractImg = picture;
            let payCaptures = this.form.contractImg.split(",");
            this.pictureList = [];
            payCaptures.forEach((element) => {
              this.pictureList.push({
                url: element,
              });
            });
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail(res.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    /** 删除按钮操作 */
    handleDelete(contractId) {
      let verifyStatus = this.customer.verifyStatus
      let contractSource = this.customer.contractSource
      let contractType = this.customer.contractType;
      Dialog.confirm({
        title: "警告",
        message: '是否确认删除【合同】ID为"' + contractId + '"的数据项?',
      }).then(
        function () {
          let api = contractType === 2 ? delnonContract : delOtherContract;
          return api(contractId)
        }).then(() => {
          Toast.success("删除成功");
          if (contractSource == '2') {
            let path = contractType === '2' ? '/cont/nonbusiness/index' : 
            contractType === '6' ?'/cont/sale2022/index':'/cont/othercontract/index';
            this.$router.push({ path });
          } else if (verifyStatus == '0') {
            this.$router.push({ path: "/cont/nocontract/index" });
          } else if (verifyStatus == '1') {
            this.$router.push({ path: "/cont/contract/index" });
          } else if (verifyStatus == '2') {
            this.$router.push({ path: "/cont/failcontract/index" });
          }
        })
        .catch(() => { });
    },
    /** 审核通过按钮操作 */
    handleSuccess(customer) {
      let contract = {
        contractId : customer.contractId,
        verifyStatus : "1"
      }
      Dialog.confirm({
        title: "警告",
        message: '是否确认审核通过【合同】ID为"' + customer.contractId + '"的数据项?',
      }).then(
        function () {
          return verifyContract(contract)
        }).then(() => {
          Toast.success("审核通过");
          this.$router.push({ path: "/cont/contract/index" })
        })
        .catch(() => { });
    },
    /** 审核驳回按钮操作 */
    handleFail(customer) {
      let contract = {
        contractId : customer.contractId,
        verifyStatus : "2"
      }
      Dialog.confirm({
        title: "警告",
        message: '是否确认审核驳回【合同】ID为"' + customer.contractId + '"的数据项?',
      }).then(
        function () {
          return verifyContract(contract)
        }).then(() => {
          Toast.success("审核驳回");
          this.$router.push({ path: "/cont/failcontract/index" })
        })
        .catch(() => { });
    },
    //客户回访记录重置
    orderFormReset() {
      this.orderForm = {
        paymentMoney: null,
        serviceFee: null,
        adFee: null,
        launchType: null,
        businessType: null,
        payCapture: null,
        content: null,
      };
      // this.resetForm("orderForm");
    },
    //修改合同
    async editContractBeforeClose(type, done) {
      if (type === "confirm") {
        try {
          await this.$refs["form"].validate();
          if (this.form.contractSource == "2") {
            let api = this.form.contractType === "2" ? updateNonContract : updateOtherContract;
            api(this.form).then((response) => {
              Toast.success("修改成功");
              this.show = false;
              if (this.deleteFileToUcloudList.length > 0) {
                deleteFileToUcloud(this.deleteFileToUcloudList);
              }
              this.init();
            });
          } else if (this.form.verifyStatus == "2") {
            updateFailContract(this.form).then((response) => {
              Toast.success("修改成功");
              this.show = false;
              if (this.deleteFileToUcloudList.length > 0) {
                deleteFileToUcloud(this.deleteFileToUcloudList);
              }
              this.init();
            });
          } else if (this.form.verifyStatus == "0") {
            updateNoContract(this.form).then((response) => {
              Toast.success("修改成功");
              this.show = false;
              if (this.deleteFileToUcloudList.length > 0) {
                deleteFileToUcloud(this.deleteFileToUcloudList);
              }
              this.init();
            });
          }
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      } else {
        return done();
      }
    },
    submitUpdate() {
      if (this.form.contractSource == "2") {
        let api = this.form.contractType === "2" ? updateNonContract : updateOtherContract;
        api(this.form).then((response) => {
          Toast.success("修改成功");
          this.show = false;
          this.init();
        });
      } else if (this.form.verifyStatus == "2") {
        updateFailContract(this.form).then((response) => {
          Toast.success("修改成功");
          this.show = false;
          this.init();
        });
      } else if (this.form.verifyStatus == "0") {
        updateNoContract(this.form).then((response) => {
          Toast.success("修改成功");
          this.show = false;
          this.init();
        });
      }
    },
    addVisit() {
      this.visitForm = [];
      this.show = true;
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === 'businessTypeId') {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === 'serviceTypeId') {
        this.serviceTypeTreeOptions = this.serviceTypeTreeOptions?this.serviceTypeTreeOptions:this.$store.state.dictOptions.serviceTypeTree;
        this.picker.columns = this.serviceTypeTreeOptions.map(ele => this.serviceNormalizer(ele))
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      // 产品类型
      if (this.picker.formKey === 'businessTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.businessTypeName = value[0] + '/' + value[1]
            let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
            if (obj != null) {
              this.form.businessType = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
            }
          }

        } else {
          this.form.businessTypeName = value[0]
          let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.form.businessType = obj.businessTypeId
          }
        }

      }
      // 业务类型
      if (this.picker.formKey === 'serviceTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.serviceTypeName = value[0] + '/' + value[1]
            let obj = this.serviceTypeTreeOptions.find(item => item.serviceTypeName === value[0])
            if (obj != null) {
              this.form.serviceTypeId = obj.children.find(item => item.serviceTypeName === value[1]).serviceTypeId
            }
          }

        } else {
          this.form.serviceTypeName = value[0]
          let obj = this.serviceTypeOptions.find(item => item.serviceTypeName === value[0])
          if (obj != null) {
            this.form.serviceTypeId = obj.serviceTypeId
          }
        }
      }
      this.picker.visible = false;
    },

    pickerCancel() {
      this.picker.visible = false;
    },
    readContractFiles(contractFiles) {
      // 微软提供的方法
      window.open(contractFiles);
    },
    pickerChange() { },
    handleUpdate(customer) {
      this.reset()
      this.fileList = []
      this.fileList1 = []
      this.fileList2 = []
      this.pictureList = []
      this.deleteFileToUcloudList = []
      let contractId = customer.contractId;
      let contractSource = customer.contractSource;
      let verifyStatus = customer.verifyStatus;
      if (contractSource == "2") {
        let api = customer.contractType === "2" ? getNonBusinessContract : getOtherContract;
        api(contractId).then((response) => {
          this.form = response.data;
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            let contractImgs = this.form.contractImg.split(",")
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            });
          }
          this.forField()
          this.show = true;
        });
      } else if (verifyStatus == "0") {
        getNoContract(contractId).then((response) => {
          this.form = response.data;
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            let contractImgs = this.form.contractImg.split(",")
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            });
          }
          this.forField()
          this.show = true;
        });
      } else if (verifyStatus == "1") {
        getContract(contractId).then((response) => {
          this.form = response.data;
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            let contractImgs = this.form.contractImg.split(",")
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            });
          }
          this.forField()
          this.show = true;
        });
      } else if (verifyStatus == "2") {
        getFailContract(contractId).then((response) => {
          this.form = response.data;
          if (this.form.contractImg != null && this.form.contractImg.length > 0) {
            let contractImgs = this.form.contractImg.split(",")
            contractImgs.forEach(element => {
              this.pictureList.push({
                url: element
              })
            });
          }
          this.forField()
          this.show = true;
        });
      }

    },
    forField() {
      this.contractTypeOptions = this.$store.state.dictOptions.contractType;
      this.contractStatusOptions = this.$store.state.dictOptions.contractStatus;
      this.payModeOptions = this.$store.state.dictOptions.payMode;
      let contractType = this.contractTypeOptions.find((item, index) => {
        return item.dictValue == this.form.contractType;
      })
      let contractStatus = this.contractStatusOptions.find((item, index) => {
        return item.dictValue == this.form.contractStatus;
      })
      let payMode = this.payModeOptions.find((item, index) => {
        return item.dictValue == this.form.payMode;
      })
      if (contractType != null) {
        this.form.contractTypeName = contractType.dictLabel
      }
      if (contractStatus != null) {
        this.form.contractStatusName = contractStatus.dictLabel
      }
      if (payMode != null) {
        this.form.payModeName = payMode.dictLabel
      }
    },
    handleAdd() {
      this.title = "添加其他合同";
      this.reset();
      this.show = true;
    },
    // readFile(url, title) {
    //   this.readTitle = title;
    //   this.pdfSrc = url;
    //   this.getNumPages(this.pdfSrc);
    //   this.readFiles = true;
    // },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        businessTypeName: null,
        businessType: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractImg: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

.pdf-box {
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
  max-width: 1024px;
  width: 100%;
  // overflow-x: hidden;
  height: 900px;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
  font-size: 0.36rem;
  overflow: scroll;
  span {
    width: 100%;
  }
}
.custclue-container {
  height: 100vh;
  background-color: #eee;
  font-size: 20px;
  .title {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    font-size: 36px;
    span {
      margin-left: 5px;
      font-size: 30px;
      font-weight: bold;
    }
    i {
      font-size: 14px;
      color: #ccc;
      margin-left: 5px;
      font-style: normal;
    }
    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .section {
    padding-top: 20px;
  }
  .title_name {
    font-size: 30px;
    padding: 20px 0;
  }
  .custclue-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 20px 10px 10px 30px;
  }
  .tag-wrapper {
    display: flex;
    justify-content: center;
  }
  .b-g-w {
    background-color: #fff;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }

  .key{
    font-size: 0.38rem;
    color: #333;
    width: 1.9rem;
    text-align: left;
  }
  .key3{
    font-size: 0.38rem;
    color: #333;
    width: 2.3rem;
    text-align: left;
  }
  .value{
    font-size: 0.38rem;
    color: #666;
  }
  .concat-container {
    background-color: #fff;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 90px;
    .concat-header {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .concat-list {
      .concat-item {
        border-bottom: 1px solid #eee;
        margin-left: 15px;
        margin-right: 15px;
        padding: 20px;
        .content-footer {
          color: #ccc;
        }
        span {
          font-size: 22px;
        }
      }
    }
  }
}
.payimg {
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  .title {
    margin-top: 10px;
  }
  .imgList {
    width: 100%;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    .img {
      width: 120px;
      height: 100px;
      margin-right: 10px;
      margin-bottom: 10px;
      // margin-left: 15px;
    }
  }
}
.flex-1 {
  display: flex;
  flex: 1;
}
.card-box {
  display: flex;
  margin-bottom: 0.35rem;
  font-size: 28px;
  color: #999;
  .value {
    flex: 1;
  }
}
.grid-span {
  font-size: 30px;
  color: #646566;
  a {
    color: #646566;
  }
}
.grid-span-1 {
  font-size: 12px;
  color: #646566;
}
.van-grid {
  margin-bottom: 10px;
}
.van-grid-item {
  flex: 1;
}
.van-divider {
  margin-top: 20px 0;
}
</style>
